import { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { cn } from '@/utils';
export const WithLabel = (props: WithLabelProps) => {
  const {
    label,
    subLabel,
    helperText,
    className,
    children,
    errorMessage,
    ...rest
  } = props;
  return <div className={cn('flex flex-col gap-3xs', className)} {...rest} data-sentry-component="WithLabel" data-sentry-source-file="WithLabel.tsx">
      <div className={'flex flex-col gap-4xs'}>
        <div className={'flex items-center gap-3xs'}>
          <span className={'text-body-lg font-bold'}>{label}</span>
          {!!subLabel && <span className={'text-caption-md font-semibold text-assistive'}>
              {subLabel}
            </span>}
        </div>
        {!!helperText && <span className={'text-body-sm font-medium text-alternative'}>
            {helperText}
          </span>}
      </div>
      {children}
      {!!errorMessage && <span className={'pl-xs text-caption-md font-medium text-destructive'}>
          {errorMessage}
        </span>}
    </div>;
};
export type WithLabelProps = ComponentPropsWithoutRef<'div'> & {
  label: ReactNode;
  subLabel?: ReactNode;
  helperText?: ReactNode;
  errorMessage?: ReactNode;
};